import { Separator } from "@pharaday/lighthouse";
import type { ReactNode } from "react";

export type NavbarPageTitleProps = {
  children: ReactNode;
};

const PageTitle = ({ children }: NavbarPageTitleProps) => {
  return (
    <>
      <Separator orientation="vertical" className="h-4 text-neutral-80" />
      <span className="text-sm font-semibold text-neutral-50">{children}</span>
    </>
  );
};

export default PageTitle;
